import axios from 'axios';
import { PropertyImport } from '../../types/PropertyImport';

class PropertyImportsService {
  async getAll(): Promise<PropertyImport[]> {
    const result = await axios.get('/property-imports');
    return result.data.map(mapFromApiResponse);
  }

  async get(id: string): Promise<PropertyImport> {
    const result = await axios.get(`/property-imports/${id}`);
    return result.data && mapFromApiResponse(result.data);
  }

  async create(postData: PropertyImport, file): Promise<void> {
    const formData = {
      file: file,
      name: postData.name,
      creation: postData.creation,
    };
    return axios.post(`/property-imports`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async print(id: string): Promise<Buffer> {
    const result = await axios.get(`/property-imports/${id}/pdf`, {
      responseType: 'arraybuffer',
    });
    return result.data;
  }

  async delete(id: string): Promise<void> {
    return axios.delete(`/property-imports/${id}`);
  }
}

const mapFromApiResponse = (propertyImport: any): PropertyImport => {
  return {
    ...propertyImport,

    creationDate: propertyImport.creationDate && new Date(propertyImport.creationDate),
  };
};

const propertyImportsService = new PropertyImportsService();
export default propertyImportsService;
